import { useEffect, useRef } from "react";

/** Close modals when a courier mutation finishes successfully (shared loading flag). */
export function useCourierMutationDone(loading, apiError, onSuccess) {
  const wasLoading = useRef(false);
  const onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;

  useEffect(() => {
    if (wasLoading.current && !loading && !apiError) {
      onSuccessRef.current();
    }
    wasLoading.current = loading;
  }, [loading, apiError]);
}
